import { gql } from '@apollo/client';


export const GET_RADIO_LOG = gql`
  query GET_RADIO_LOG($originatorId: ID!, $officerId: ID, $oriIds: String, $incidentNumber: String, $badge: String, $logCode: String, $startDate: String, $endDate: String, $perPage: Int, $page: Int){
    getRadioLog(originatorId: $originatorId, officerId: $officerId, oriIds: $oriIds, incidentNumber: $incidentNumber, badge: $badge, logCode: $logCode, startDate: $startDate, endDate: $endDate, perPage: $perPage, page: $page) {
      id
      createdAt
      originator {
        id
        deptAttribute {
          badge
          ori {
            abbreviation
          }
        }
        personalAttribute {
          firstName
          lastName
        }
      }
      officer {
        id
        deptAttribute {
          badge
          ori {
            abbreviation
          }
        }
        personalAttribute {
          firstName
          lastName
        }
      }
      incident {
        id
        incidentNumber
        locked
        sealed
      }
      logCode {
        name
      }
      logEntry
    }    
  }
`